import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api
      .post("/auth/google-session", { session_id: sessionId })
      .then(({ data }) => {
        setUser(data);
        navigate("/dashboard", { replace: true, state: { user: data } });
      })
      .catch(() => navigate("/login", { replace: true }));
  }, [location.hash, navigate, setUser]);

  return <div className="min-h-screen bg-void" data-testid="auth-callback" />;
};
